// classi "week-picker" e "date-container" del WeekPicker classico
import '../date-picker/week-picker/week-picker.css';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { IconButton } from '@mui/material';
import { memo } from 'react';
import { Else, If, Then } from 'react-if';

import { DateInterface } from '../../../../interface/date';
import { MultiStoreDay } from './multi-store-day';
import { MultiStoreLoadingDates } from './multi-store-loading-dates';

interface MultiStoreWeekProps {
  data?: DateInterface;
  // giorni liberi solo negli altri centri inclusi, con il puntino
  elsewhereDates: string[];
  selectedDay?: string;
  isPending: boolean;
  isPrevDisabled: boolean;
  isNextDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSelectDay: (date: string) => void;
}

// Riga della settimana con le stesse frecce e gli stessi cerchi del WeekPicker classico
export const MultiStoreWeek = memo(function MultiStoreWeek({
  data,
  elsewhereDates,
  selectedDay,
  isPending,
  isPrevDisabled,
  isNextDisabled,
  onPrev,
  onNext,
  onSelectDay,
}: MultiStoreWeekProps): JSX.Element {
  return (
    <div className="week-picker">
      <IconButton
        disabled={isPrevDisabled}
        onClick={onPrev}
        className="date-container"
      >
        <KeyboardArrowLeftIcon style={{ fontSize: '35px' }} />
      </IconButton>
      <If condition={isPending}>
        <Then>
          <MultiStoreLoadingDates />
        </Then>
        <Else>
          {Object.entries(data ?? {}).map(([date, day]) => (
            <MultiStoreDay
              key={date}
              date={date}
              dayOfWeek={day.daysOfWeek}
              dayOfMonth={day.day}
              isActive={day.active}
              isSelected={date === selectedDay}
              isElsewhereOnly={elsewhereDates.includes(date)}
              onSelect={onSelectDay}
            />
          ))}
        </Else>
      </If>
      <IconButton
        disabled={isNextDisabled}
        onClick={onNext}
        className="date-container"
      >
        <KeyboardArrowRightIcon style={{ fontSize: '35px' }} />
      </IconButton>
    </div>
  );
});
